export default __webpack_public_path__ + "static/media/dashboard.6b9b6cb6.svg";